module.exports = __webpack_public_path__ + "static/media/robot-prod.a24587e3.png";